/**
 * dom queries
 * it has to be deleted in the future
 */
export const getDOMElement = <T = HTMLElement>(selector: string): T | null =>
  document.querySelector(selector.trim()) as T | null;

export const getDOMElements = (selector: string): NodeListOf<HTMLElement> | null =>
  document.querySelectorAll(selector.trim());

export const addDOMClass = (selector: string, className: string): void => {
  getDOMElement(selector)?.classList.add(className);
};

export const removeDOMClass = (selector: string, className: string): void => {
  getDOMElement(selector)?.classList.remove(className);
};

export const getDOMModalsAmount = (): number =>
  (document.querySelector('body')?.querySelectorAll('.modal') as NodeList).length;

export const getDOMAbsoluteElementHeight = (el: HTMLElement | null): number => {
  if (!el) {
    return 0;
  }
  const styles = window.getComputedStyle(el);
  const margin: number = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom) || 0;

  return Math.ceil(el.offsetHeight + margin);
};

export const setDOMElementCss = (element: HTMLElement | null, styles: Partial<CSSStyleDeclaration>): void => {
  if (element) {
    const cssText = Object.entries(styles).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined) {
        /** camelCase to css-case */
        acc += `${key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}: ${value};`;
      }

      return acc;
    }, '');

    element.style.cssText = `${element.style.cssText}${cssText}`;
  }
};

/**
 * native scroll to the top of the window
 * todo find a better way to scroll
 */
export const scrollWindowToTop = (timeout = 0): void => {
  // some actions (js code) may cancel this if is run at the same time
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, timeout);
};

// todo find a better way to scroll
export const scrollIntoView = (elem: Element | null): void => {
  if (elem) {
    setTimeout(() => {
      elem.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }, 0);
  }
};
